export class AzureVaultConfig {
    'tenantId';
    'storageAccount';
    'resourceGroup';
    'encryptionKey';
    'cmkKeyVaultTenantId';
    'cmkAppRegistrationId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageAccount",
            "baseName": "storageAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "cmkKeyVaultTenantId",
            "baseName": "cmkKeyVaultTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "cmkAppRegistrationId",
            "baseName": "cmkAppRegistrationId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureVaultConfig.attributeTypeMap;
    }
    constructor() {
    }
}
